import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import _map from 'lodash/map';
import _keyBy from 'lodash/keyBy';
import _get from 'lodash/get';
import _reduce from 'lodash/reduce';
import _castArray from 'lodash/castArray';
import _isEmpty from 'lodash/isEmpty'; // Constants

import { EMPTY_OBJECT } from '../app.constants'; // Readers

import mediaReader from '../readers/Media'; // Services

import MediaApi from '../services/MediaRepository';

var getS3MediaData = function getS3MediaData(s3MediaResponse) {
  return _get(s3MediaResponse, 'data', []);
};

var s3ResponseInterceptor = function s3ResponseInterceptor(mediaList) {
  return _reduce(mediaList, function (acc, media) {
    return [].concat(_toConsumableArray(acc), [_defineProperty({}, media.mediaId, _get(media, 'responseMap.url'))]);
  }, []);
};

export var fetchMediaUrls = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var mediaIdObject,
        s3MediaCdmsResponse,
        s3MediaDseResponse,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            mediaIdObject = _args.length > 0 && _args[0] !== undefined ? _args[0] : EMPTY_OBJECT;

            if (!_isEmpty(mediaIdObject.cDMSMediaList)) {
              _context.next = 5;
              break;
            }

            _context.t0 = [];
            _context.next = 8;
            break;

          case 5:
            _context.next = 7;
            return MediaApi.getCDMSSignedUrls(mediaIdObject.cDMSMediaList);

          case 7:
            _context.t0 = _context.sent;

          case 8:
            s3MediaCdmsResponse = _context.t0;

            if (!_isEmpty(mediaIdObject.dSEMediaList)) {
              _context.next = 13;
              break;
            }

            _context.t1 = [];
            _context.next = 16;
            break;

          case 13:
            _context.next = 15;
            return MediaApi.getDSESignedUrls(mediaIdObject.dSEMediaList);

          case 15:
            _context.t1 = _context.sent;

          case 16:
            s3MediaDseResponse = _context.t1;
            return _context.abrupt("return", [].concat(_toConsumableArray(s3ResponseInterceptor(getS3MediaData(s3MediaCdmsResponse))), _toConsumableArray(_castArray(getS3MediaData(s3MediaDseResponse)))));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMediaUrls() {
    return _ref2.apply(this, arguments);
  };
}();

var setMediaObject = function setMediaObject(mediaObj) {
  return function (mediaUrl, index) {
    return _objectSpread(_objectSpread({}, mediaObj[index]), {}, {
      url: mediaUrl
    });
  };
};

var mapNameToResponse = function mapNameToResponse(mediaList, mediaUrlList) {
  var mediaUrlObject = _reduce(mediaUrlList, function (acc, media) {
    return _objectSpread(_objectSpread({}, acc), media);
  }, {});

  var mediaObj = _keyBy(mediaList, mediaReader.mediaId);

  return _map(mediaUrlObject, setMediaObject(mediaObj));
};

var mapMediaListToMediaIds = function mapMediaListToMediaIds(mediaList) {
  return _reduce(mediaList, function (acc, _ref3) {
    var dseMedia = _ref3.dseMedia,
        mediaId = _ref3.mediaId;
    return dseMedia ? _objectSpread(_objectSpread({}, acc), {}, {
      dSEMediaList: [].concat(_toConsumableArray(acc.dSEMediaList), [mediaId])
    }) : _objectSpread(_objectSpread({}, acc), {}, {
      cDMSMediaList: [].concat(_toConsumableArray(acc.cDMSMediaList), [mediaId])
    });
  }, {
    dSEMediaList: [],
    cDMSMediaList: []
  });
};

export var getMediaWithSignedUrls = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(mediaList) {
    var mediaIdObject, mediaUrlList;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            mediaIdObject = mapMediaListToMediaIds(mediaList);
            _context2.next = 3;
            return fetchMediaUrls(mediaIdObject);

          case 3:
            mediaUrlList = _context2.sent;
            return _context2.abrupt("return", mapNameToResponse(mediaList, mediaUrlList));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getMediaWithSignedUrls(_x) {
    return _ref4.apply(this, arguments);
  };
}();